import ubistApi from "@/lib/ubistApi";

export default function useManualDownload() {
  function parseFileName(disposition) {
    if (!disposition) return "";

    // 1) RFC5987 방식(filename*=UTF-8''percentEncoded)
    const starKey = "filename*=";
    const idxStar = disposition.indexOf(starKey);
    if (idxStar !== -1) {
      let part = disposition.substring(idxStar + starKey.length);
      // part 예시: "UTF-8''UBIST%20…%20통합.pdf; filename=…"
      // UTF-8'' 제거
      part = part.replace(/^UTF-8''/, "");
      // 세미콜론 이전만
      const encoded = part.split(";")[0].trim();
      return decodeURIComponent(encoded);
    }
    // 2) fallback: filename="…"
    const match = disposition.match(/filename="([^"]+)"/i);
    if (match && match[1]) {
      return match[1];
    }
    return "";
  }

  const downloadBlob = (blobData, fileName) => {
    const blob = new Blob([blobData], { type: blobData.type });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const manualDownload = async (menuCode) => {
    try {
      const response = await ubistApi.downloadManualByMenuCode(menuCode);
      // 1) 헤더에서 파일명 파싱
      const disp =
        response.headers["content-disposition"] ||
        response.headers["Content-Disposition"];
      const headerName = parseFileName(disp);
      // 2) 헤더 이름 없으면 fallback
      const fileName = headerName;

      // 3) 파일명이 없으면 더 이상 진행하지 않음
      if (!fileName) {
        alert("File not found");
        return;
      }

      downloadBlob(response.data, fileName);
    } catch (error) {
      console.error("manualDownload error:", error);
    }
  };
  const manualDownLoad = manualDownload;

  return { manualDownload, manualDownLoad };
}
